import { render, staticRenderFns } from "./LinkSecondarySmall.vue?vue&type=template&id=6055e6a1&scoped=true&"
import script from "./LinkSecondarySmall.vue?vue&type=script&lang=ts&"
export * from "./LinkSecondarySmall.vue?vue&type=script&lang=ts&"
import style0 from "./LinkSecondarySmall.vue?vue&type=style&index=0&id=6055e6a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055e6a1",
  null
  
)

export default component.exports